import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CurrentUser, SettingDataOutputModel } from '@travel/shared';
import { DataConfig, SharedService, StorageService } from '@travel/shared/services';

@Injectable()
export class PublicRegisterService {
  settingData: SettingDataOutputModel = DataConfig.get('globalSetting');
  constructor(private _httpClient: HttpClient, private _storageService: StorageService, private _sharedService: SharedService, @Inject('environment') private environment: any) {}

  captchaGenerate(): Promise<any> {
    return this._sharedService.captchaGenerate();
  }

  dyanimcLoginFirstStep(param: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = new HttpParams();
      params = params.set('username', param.username);
      params = params.set('captchaCode', param.captchaCode);
      params = params.set('captchaId', param.captchaId);
      params = params.set('forgotPasswordFlag', param.forgotPasswordFlag);
      params = params.set('stepNumber', '1');
      params = params.set('authenticationType', 'dynamic');
      params = params.set('organizationPersonRootId', this.settingData.agencyId);
      params = params.set('whiteLabelId', this.settingData.whiteLabelId);

      //
      let headers = new HttpHeaders();
      headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
      //
      const body = {};
      const options = { params, headers };
      //
      this._httpClient.post(`${this.environment.authURL}/tsv/cita`, body, options).subscribe({
        next: (res: any) => resolve(res.result),
        error: (err: any) => reject(err),
      });
    });
  }

  dynamicLoginNextStep(param: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const user: CurrentUser = new CurrentUser();
      let params = new HttpParams();
      params = params.set('username', param.username);
      params = params.set('password', param.password);
      params = params.set('tokenId', param.tokenId);
      params = params.set('userPassword', param.userPassword);
      params = params.set('forgotPasswordFlag', param.forgotPasswordFlag);
      params = params.set('grant_type', 'password');
      params = params.set('authenticationType', 'dynamic');
      params = params.set('stepNumber', '2');
      params = params.set('organizationPersonRootId', String(this.settingData.agencyId));
      params = params.set('whiteLabelId', this.settingData.whiteLabelId);
      //
      let headers = new HttpHeaders();
      headers = headers.set('Authorization', 'Basic ' + btoa('clientAppId:test'));
      headers = headers.set('Content-Type', 'form');

      // headers = headers.set('Content-Type', 'application/json');
      const body = {};
      const options = { headers, params };
      //
      this._httpClient
        .post(`${this.environment.authURL}/oauth/token`, body, options)
        .toPromise()
        .then((res: any) => {
          user.id = res.user_id;
          user.expiresIn = res.expires_in;
          user.token = res.access_token;
          user.refreshToken = res.refresh_token;
          user.username = param.username;
          user.whiteLabelId = this.settingData.whiteLabelId;
          // handle user profile info
          return this._httpClient
            .get(`${this.environment.baseURL}/userProfile/get/${res.user_id}`, {
              headers: { Authorization: `Bearer ${res.access_token}` },
            })
            .toPromise();
        })
        .then((c: any) => {
          const { userAccountId, firstName, lastName, birthday, nationalCode, email, iban } = c.result;
          (user.userAccountId = userAccountId),
            (user.firstName = firstName),
            (user.lastName = lastName),
            (user.birthday = birthday),
            (user.nationalCode = nationalCode),
            (user.email = email),
            (user.iban = iban ? 'IR' + iban : null);
          // this.currentUserSubject.next(user);
          // this.refresh();
          this._storageService.set('USER_PROFILE', user);
          resolve(c.result as any);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
}
